module.exports = __webpack_public_path__ + "media/images/flags/rw-26854553b660fa5e4982e8253545fa3c.svg";